import { useFeatureFlags } from '@context/launch-darkly/LDProvider';

export const useNewPdDesignEnabled = () => {
  const { newPdDesign } = useFeatureFlags();
  return newPdDesign;
};
